<!--<mat-progress-bar *ngIf="isLoading"-->
<!--                  mode="buffer"></mat-progress-bar>-->
<!--<p *ngIf="isLoading">{{loadingMessage}}</p>-->

<!--<script src="main-dynamic-form.component.ts"></script>-->
<h6 *ngIf="!isLoading && showRequiredTitle" style="color: red">* Required</h6>
<div *ngIf="showGeneralErrorMessage" class="text-red-700 py-2 pl-4">
  {{ generalErrorMessage }}
</div>
<ng-container *ngIf="previousDocuments.length">
  <p class="font-size-16 py-1">Previous Attachment</p>
  <hr class="py-1"/>
  <mat-progress-bar *ngIf="fetchingAttachment" mode="buffer"></mat-progress-bar>
  <div class="row">

    <ng-container *ngFor="let document of previousDocuments || []">
      <div class="col-span-12 md:col-span-6">
        <div class="attachment">
          <div class="attach-button">
            <button
              (click)="attachmentView.emit(document)"
              class="mat-focus-indicator attach-button mat-raised-button mat-button-base mat-default"
              color="default"
              style="width: 100%; height: 45px; margin-top: 5px;"
              title="{{document?.title ? document.title : 'View Attached File'}}"
              type="button"
            >
                <span class="mat-button-wrapper">
                  <mat-icon class="mat-icon material-icons mat-ligature-font mat-icon-no-color" data-mat-icon-type="font"
                            role="img">attach_file</mat-icon>
                  {{ document?.title ? document.title : 'View Attached File' }}
                </span>
              <span class="mat-ripple mat-button-ripple" matripple=""></span>
              <span class="mat-button-focus-overlay"></span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
<hr *ngIf="form && showRequiredTitle" class="py-1"/>

<div *ngIf="!form" class="w-full hidden lg:block p-4 border border-gray-200 rounded shadow animate-pulse md:p-6 dark:border-gray-700 col-span-2"
     role="status">
  <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4 mx-auto max-w-[540px]"></div>
  <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
</div>

<form
  (submit)="onSubmit($event)"
  *ngIf="form"
  [formGroup]="form"
  autocomplete="off"
  class="dynamic-form"
>

  <div [@listAnimation]="(sortedFields || []).length" class="row {{ showRequiredTitle ? '' : '!p-0' }}">
    <ng-container *ngFor="let field of sortedFields || []">
      <div *ngIf="field?.headingTitle; else formFieldInput"
           [class]="field.rowClass || 'col-span-12'">
        <p class="font-semibold my-3">{{ field?.headingTitle }}</p>
      </div>

      <ng-template #formFieldInput>
        <div
          *ngIf="isVisible(field)"
          [class]="field.rowClass || 'col-span-12 md:col-span-6'"
          [ngClass]="{ spaced: spaced }"
        >
          <ng-container
            (cancelForm)="cancelForm()"
            (fieldValue)="fieldValue($event)"
            [cancelText]="cancelText"
            [confirmFirst]="confirmFirst"
            [confirmMessage]="confirmMessage"
            [field]="field"
            [group]="form"
            [hideSave]="hideSave"
            [loadingMessage]="loadingMessage"
            [loading]="loading"
            [optionData]="(field.options ? (field.options | optionsObservable | async) : { loading: false, value: [] }) || undefined"
            [saveText]="saveText"
            [showCancel]="showCancel"
            appDynamicField
          ></ng-container>
        </div>
      </ng-template>
    </ng-container>
  </div>
</form>
